/**
 * user 注册/找回密码流程模块英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 */
export default {
  // Register.vue
  '注册': 'Register',
  '用户名不能为空': 'Username cannot be empty',
  '请输入用户名': 'Please enter the username',
  '强度：': 'Strength: ',
  '请至少输入 8 个字符。请不要使用容易被猜到的密码。': 'Please enter at least 8 characters. Do not use a password that is easy to guess.',
  '至少8位密码，区分大小写': 'At least 8 characters, case sensitive',
  '确认密码': 'Confirm Password',
  '请输入正确的邮箱地址': 'Please enter a valid email address',
  '邮箱': 'Email',
  '请输入正确的手机号': 'Please enter a valid mobile phone number',
  '11 位手机号': '11-digit mobile number',
  '验证码': 'Captcha',
  '获取验证码': 'Get Captcha',
  '使用已有账户登录': 'Sign in with an existing account',
  '低': 'Low',
  '中': 'Medium',
  '强': 'Strong',
  '用户名已存在!': 'Username already exists!',
  '邮箱已存在!': 'Email already exists!',
  '密码由8位数字、大小写字母和特殊符号组成!': 'Password must be at least 8 characters with digits, upper/lowercase letters and special characters!',
  '密码强度不够': 'Password strength is too weak',
  '请输入密码': 'Please enter password',
  '两次密码不一致': 'The two passwords do not match',
  '手机号已存在!': 'Mobile number already exists!',
  '验证码发送中..': 'Sending captcha..',
  '注册失败': 'Registration failed',
  // RegisterResult.vue
  '返回首页': 'Back to Home',
  '你的账户：{v} 注册成功': 'Your account: {v} registered successfully',
  // Step1.vue
  '请输入用户账号或手机号': 'Please enter the user account or mobile number',
  '下一步': 'Next',
  '请输入用户名和手机号！': 'Please enter the username and mobile number!',
  '用户名不存在!': 'Username does not exist!',
  // Step2.vue
  '手机': 'Mobile',
  '请输入手机号': 'Please enter mobile phone number',
  '手机短信验证码': 'SMS Captcha',
  '请输入短信验证码!': 'Please enter the SMS captcha!',
  '请输入手机号码!': 'Please enter the mobile number!',
  '手机号不能为空!': 'Mobile number cannot be empty!',
  '验证错误': 'Verification failed',
  // Step3.vue
  '账号名': 'Account Name',
  '新密码': 'New Password',
  '上一步': 'Previous',
  '提交': 'Submit',
  '用户名不能为空!': 'Username cannot be empty!',
  '密码由8位数字、大小写字母和特殊符号组成!!': 'Password must be 8+ characters with digits, upper/lowercase letters and special characters!!',
  '密码不能为空!': 'Password cannot be empty!',
  '更改密码失败': 'Failed to change password',
  // Step4.vue
  '更改密码成功': 'Password changed successfully',
  '将在{time}秒后返回登录页面.': 'Returning to the sign-in page in {time} seconds.',
  // Alteration.vue
  '手机验证': 'Phone Verification',
  '完成': 'Finish',
  '将一个冗长或用户不熟悉的表单任务分成多个步骤，指导用户完成。': 'Split a long or unfamiliar form task into steps to guide the user through it.',
  // LoginSelectModal.vue
  '您有多个租户，请选择登录租户': 'You belong to multiple tenants, please select one',
  '请选择登录租户': 'Select a tenant',
  '您有多个部门，请选择登录部门': 'You belong to multiple departments, please select one',
  '请选择租户和部门': 'Select tenant and department',
  '请选择部门': 'Please select department',
  '请选择租户': 'Select tenant',
}
